const toggleModal = (target) => {
  $(target).toggleClass('active');
};

$(document).on('click', '[data-modal]', function () {
  $('.header__toggle').addClass('active');
  $('.modal.active').removeClass('active');
  const target = $(this).data('modal');
  const unique = $(this).attr('data-modal-unique');

  if (unique) { // if modal has unique id
    toggleModal('#modal--' + target + unique);
  } else {
    toggleModal('#modal--' + target);
  }

  // disable scroll
  $('html').toggleClass('no-scroll');

  if (!target.length) {
    return;
  }
});

$(document).keydown(function (e) {
  if (e.keyCode == 27) {
    if ($('.modal.active').length != 0) {
      $('.header__toggle').removeClass('active');
      $('.modal').removeClass('active');
      $('html').removeClass('no-scroll');
    }
  }
});

// Detect if the user is using a mobile device running Android or iOS
if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
  $('body').addClass('platform-is-mobile');
  $('.theme-icon-arrow').addClass('platform-is-mobile');
}
